// -----------------------------------------------------------------------------
// Scripts for slider on the top front page
// -----------------------------------------------------------------------------

$(document).ready(function () {

  if ($("#portfolioSlider").length > 0) {
    mainSlider($("#portfolioSlider"));
  }


});


var mainSlider = function (el) {
  el.slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: false,
    accessibility: false,
    arrows: true,
  });
};

lightbox.option({
  'albumLabel': "Zdjęcie %1 z %2"
})